var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checklist_calendar",
    "data-name": "checklist calendar",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1",
    "data-name": "\\uD0C0\\uC6D0 1",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1 1)",
    fill: "#0fbcf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_288",
    "data-name": "\\uADF8\\uB8F9 288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_191",
    "data-name": "\\uD328\\uC2A4 191",
    d: "M18.533,7.267H13.467a.633.633,0,0,0,0,1.266h5.067a.633.633,0,0,0,0-1.266Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_192",
    "data-name": "\\uD328\\uC2A4 192",
    d: "M10.933,6.633V9.167a.634.634,0,0,0,1.267,0V6.633a.634.634,0,1,0-1.267,0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_193",
    "data-name": "\\uD328\\uC2A4 193",
    d: "M19.8,6.633V9.167a.634.634,0,0,0,1.267,0V6.633a.634.634,0,1,0-1.267,0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_194",
    "data-name": "\\uD328\\uC2A4 194",
    d: "M24.233,11.067H21.7a.633.633,0,0,0,0,1.266h2.533V23.1a.632.632,0,0,1-.633.633H8.4a.632.632,0,0,1-.633-.633V12.333h11.4a.633.633,0,0,0,0-1.266H7.767v-1.9A.634.634,0,0,1,8.4,8.533H9.667a.633.633,0,1,0,0-1.266H8.4a1.9,1.9,0,0,0-1.9,1.9V23.1A1.9,1.9,0,0,0,8.4,25H23.6a1.9,1.9,0,0,0,1.9-1.9V9.167a1.9,1.9,0,0,0-1.9-1.9H22.333a.633.633,0,0,0,0,1.266H23.6a.634.634,0,0,1,.633.634Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_195",
    "data-name": "\\uD328\\uC2A4 195",
    d: "M12.55,17.866l1.97,2.463a.634.634,0,0,0,.968.025l3.941-4.433a.634.634,0,1,0-.947-.842L15.04,18.951l-1.5-1.876a.633.633,0,1,0-.989.791Z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.3dc9b028aaa084fcac96472e74ca1077.svg";
export { ForwardRef as ReactComponent };